import { IHttpApi } from '@cian/http-api';
import {
  IGetRecommendedOffersRequest,
  TGetRecommendedOffersResponse,
  fetchGetRecommendedOffers,
} from '../repositories/search-engine/v3/get-recommended-offers';
import {
  IGetSimilarOffersRequest,
  TGetSimilarOffersResponse,
  fetchGetSimilarOffers,
} from '../repositories/search-engine/v3/get-similar-offers';
import {
  fetchGetOffersFromHistory,
  TGetOffersFromHistoryResponse,
} from '../repositories/search-engine/v1/get-offers-from-history';

export function getItemBasedSimilarOffers(
  httpApi: IHttpApi,
  parameters: IGetSimilarOffersRequest,
): Promise<TGetSimilarOffersResponse> {
  return fetchGetSimilarOffers({ httpApi, parameters });
}

export function getUserBasedSimilarOffers(
  httpApi: IHttpApi,
  parameters: IGetRecommendedOffersRequest,
): Promise<TGetRecommendedOffersResponse> {
  return fetchGetRecommendedOffers({ httpApi, parameters });
}

export function getHistoryBasedSimilarOffers(httpApi: IHttpApi): Promise<TGetOffersFromHistoryResponse> {
  return fetchGetOffersFromHistory({ httpApi, parameters: {} });
}
